import React from "react";
import * as c from "../../../../constants";
import FacilityEditor from "../../../Forms/Onboarding/FacilityEditor";
import ValetAreaEditor from "../../../Forms/Onboarding/ValetAreaEditor";
import FacilityGroupEditor from "../../../Forms/Onboarding/FacilityGroupEditor";
import AreaEditor from "../../../Forms/Onboarding/AreaEditor";
import GenericEditor from "../../../Forms/Onboarding/DeviceEditor";
import {useStyles} from "../../../EntityCard/Expanded/Settings/styles";

import {Drawer} from "@material-ui/core";
import {shallowEqual, useSelector} from "react-redux";
import {selectOrgTreeEntityById} from "../../../../state/slices/OrgTree";

export const EntityDrawerEditor = ({entityID, onClose, showEditDrawer}) => {
    const classes = useStyles();
    const entity = useSelector((state) => {
        const _entity = selectOrgTreeEntityById(state, entityID);

        return {
            entityID: entityID,
            parentEntityID: _entity?.parententityid,
            typeID: _entity?.typeid,
            deviceMode: _entity?.settings?.find((setting) => setting.name === "devicemode")?.value ?? null,
        }
    }, shallowEqual);


    const drawerContent = () => {
        if (entity.typeID === c.ENTITY_TYPE.Facility) {
            return (
                <div style={{padding: 10}}>
                    <FacilityEditor
                        entityID={entity.entityID}
                        parentEntityID={entity.parentEntityID}
                        onCancel={onClose}
                        onSubmitComplete={onClose}
                        onDeleteComplete={onClose}
                    />
                </div>
            );
        } else if (entity.typeID === c.ENTITY_TYPE.ValetArea) {
            return (
                <div style={{padding: 10}}>
                    <ValetAreaEditor
                        entityID={entity.entityID}
                        parentEntityID={entity.parentEntityID}
                        onCancel={onClose}
                        onSubmitComplete={onClose}
                        onDeleteComplete={onClose}
                    />
                </div>
            );
        } else if (entity.typeID === c.ENTITY_TYPE.FacilityGroup) {
            return (
                <div style={{padding: 10}}>
                    <FacilityGroupEditor
                        entityID={entity.entityID}
                        parentEntityID={entity.parentEntityID}
                        onCancel={onClose}
                        onSubmitComplete={onClose}
                        onDeleteComplete={onClose}
                    />
                </div>
            );
        } else if (entity.typeID === c.ENTITY_TYPE.Area) {
            return (
                <div style={{padding: 10}}>
                    <AreaEditor
                        entityID={entity.entityID}
                        parentEntityID={entity.parentEntityID}
                        onSubmitComplete={onClose}
                        onCancel={onClose}
                    />
                </div>
            );
        } else {
            return (
                <>
                    <GenericEditor
                        entityID={entity.entityID}
                        parentEntityID={entity.parentEntityID}
                        onCancel={onClose}
                        onSaveComplete={onClose}
                        onDeleteComplete={onClose}
                        deviceMode={entity.deviceMode}
                    />
                </>
            );
        }
    };
    return (
        <Drawer
            className={classes.editorDrawer}
            anchor="right"
            open={showEditDrawer}
            classes={{
                paper: classes.drawerPaper
            }}
        >
            {drawerContent()}
        </Drawer>
    )
};